var map = {
	"./accordeon-box.svg": 522,
	"./application.svg": 523,
	"./balance.svg": 524,
	"./faq.svg": 525,
	"./files.svg": 526,
	"./footer.svg": 527,
	"./header.svg": 528,
	"./icons.svg": 529,
	"./loading.svg": 530,
	"./modal.svg": 531,
	"./ois.svg": 532,
	"./profile.svg": 533,
	"./social.svg": 534,
	"./ui.svg": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;